import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import React, { useContext } from 'react';
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { calculateTotalExperienceDuration } from "../../../utils/calculateDatesDifference";
import { parseISO } from 'date-fns';

export default function CssfExperiencesSection() {

    const { translations, formatDate, displayLanguage } = useContext( TranslationContext );
    const { isAnonymous, isExperienceHidden } = useResumeProperties();
    const { experiences, totalExperienceDuration } = useResumeDocumentSection();

    if ( isExperienceHidden ) {
        return null;
    }

    const {
        years: displayYears,
        months: displayMonths,
    } = calculateTotalExperienceDuration( experiences, totalExperienceDuration );

    return (
        <>
            <MDBRow>
                <MDBCol md="3" className="header-cv" style={ {
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end",
                    color: "#009999",
                    fontSize: "14px"
                } }>
                    <span className="fw-bold" style={ { width: "100%", textAlign: "end" } }>
                        EXPÉRIENCE<br/>PROFESSIONNELLE
                    </span>
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "end" } }>
                    <hr style={ {
                        width: "95%",
                        margin: "0px",
                        height: "8px",
                        color: "#009999",
                        marginBottom: "6px",
                        opacity: "1"
                    } }/>
                </MDBCol>
            </MDBRow>
            <MDBRow style={ { marginTop: "10px" } }>
                <MDBCol md="3" className="header-cv" style={ {
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                    color: "#009999",
                    fontSize: "14px"
                } }>
                    <span className="fw-bold" style={ { textTransform: "uppercase", textAlign: "end" } }>
                        Nombre d’années d’expérience
                    </span>
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "end" } }>
                    <p className="text-end" style={ { fontSize: "14px" } }>
                        { displayYears } an{ displayYears > 1 ? 's' : '' } { displayMonths } mois
                    </p>
                </MDBCol>
            </MDBRow>
            { !isExperienceHidden && experiences
                ?.sort((a, b) => parseISO(b?.from) - parseISO(a?.from))
                .map( ( experience, index ) => {
                    const validRoles = Array.isArray( experience.roles )
                        ? experience.roles.filter( role => role?.text && role.text.trim() !== '' )
                        : [];
                    return experience && (
                        <React.Fragment key={ index }>
                            <MDBRow style={ { marginTop: "10px" } }>
                                <MDBCol md="3" className="header-cv" style={ {
                                    display: "flex",
                                    alignItems: "start",
                                    justifyContent: "end",
                                    color: "#009999",
                                    fontSize: "14px"
                                } }>
                                    <span className="fw-bold"
                                          style={ { textAlign: "end" } }>
                                        { experience.from && ( experience.to || experience.isCurrent )
                                            ? 'De ' + formatDate( experience.from, true ) + ' à ' + ( experience.isCurrent ? translations.pdf.isCurrentLabel : formatDate( experience.to, true ) )
                                            : 'Depuis ' + formatDate( experience.from, true ) }
                                    </span>
                                </MDBCol>
                                <MDBCol md="9" className="text-start" style={ {
                                    display: "flex",
                                    alignItems: "start",
                                    flexDirection: "column",
                                    justifyContent: "start"
                                } }>
                                    <p className="text-end" style={ { fontSize: "14px" } }>
                                        { experience.jobPosition }
                                    </p>
                                    { experience.activitySector?.translations?.[ displayLanguage ] && (
                                        <p className="text-start" style={ { fontSize: "12px" } }>
                                            { experience.activitySector.translations[ displayLanguage ] }
                                        </p>
                                    ) }
                                    { experience.contractType?.translations?.[ displayLanguage ] && (
                                        <p className="text-start" style={ { fontSize: "12px" } }>
                                            { experience.contractType.translations[ displayLanguage ] }
                                        </p>
                                    ) }
                                    { validRoles.length > 0 && (
                                        <>
                                            <p className="text-end"
                                               style={ { fontSize: "12px", marginBottom: "4px" } }>
                                                { translations.pdf.rolesLabel } :
                                            </p>
                                            <ul className="mb-0 text-black"
                                                style={ { listStyleType: "- ", margin: 0 } }>
                                                { validRoles
                                                    .sort( ( a, b ) => a.order - b.order )
                                                    .map( ( role, roleIndex ) => (
                                                        <li key={ roleIndex }>
                                                            <p
                                                                className="text-start"
                                                                style={ {
                                                                    fontSize: "12px",
                                                                    color: "#4f4f4f",
                                                                    margin: 0
                                                                } }>
                                                                { role.text }
                                                            </p>
                                                        </li>
                                                    ) ) }
                                            </ul>
                                        </>
                                    ) }
                                    <p className="text-start" style={ { fontSize: "12px", width: "85%" } }>
                                        { experience.context }
                                    </p>
                                    { experience.achievement && (
                                        <p className="text-start" style={ { fontSize: "12px", whiteSpace: "pre-line" } }>
                                            { translations.pdf.achievementsLabel } : { experience.achievement }
                                        </p>
                                    ) }
                                    { experience.actions && experience.actions.length > 0 &&
                                        (
                                            <>
                                                <p className="text-end"
                                                   style={ { fontSize: "12px", marginBottom: "4px" } }>
                                                    { translations.pdf.actionsLabel } :
                                                </p>
                                                <ul className="mb-0 text-black"
                                                    style={ { listStyleType: "- ", margin: 0 } }>
                                                    { experience.actions
                                                        .sort( ( a, b ) => a.order - b.order )
                                                        .map( ( action, actionIndex ) =>
                                                            <li key={ actionIndex }>
                                                                <p
                                                                    className="text-start"
                                                                    style={ {
                                                                        fontSize: "12px",
                                                                        color: "#4f4f4f",
                                                                        margin: 0
                                                                    } }>
                                                                    { action.text }
                                                                </p>
                                                            </li>
                                                        ) }
                                                </ul>
                                            </>
                                        ) }
                                    { experience.technicalEnvironments
                                        && Array.isArray( experience.technicalEnvironments )
                                        && experience.technicalEnvironments.length > 0
                                        && (
                                            <div>
                                                <>
                                                    <p className="text-start"
                                                       style={ {
                                                           fontSize: "12px",
                                                           marginBottom: "4px",
                                                           marginTop: "16px"
                                                       } }>
                                                        { translations.pdf.technicalEnvironmentLabel }
                                                    </p>
                                                    <p className="text-start"
                                                       style={ { fontSize: "12px" } }>{ ' ' + experience.technicalEnvironments.join( ", " ) }</p>
                                                </>
                                            </div>
                                        ) }
                                    { !experience.client && (
                                        <p className="text-start" style={ { fontSize: "12px" } }>
                                            { isAnonymous && experience.employer ? translations.pdf.employerLabel
                                                : experience.employer }
                                        </p>
                                    ) }
                                    { experience.client && (
                                        <p className="text-start" style={ { fontSize: "12px" } }>
                                            En mission chez <strong>{ experience.client }</strong>
                                        </p>
                                            ) }
                                </MDBCol>
                            </MDBRow>
                        </React.Fragment>
                    );
                } ) }
        </>
    );
}
